import {fsa, fsaError, fsaPayloadByKeys, fsaPayload} from './helpers'

/**
 * Exchange Flow Actions
 */
export const START_REPLACEMENTS = 'replacements/start replacements flow'
export const startReplacements = fsaPayload(START_REPLACEMENTS)

export const END_REPLACEMENTS = 'replacements/end replacements flow'
export const endReplacements = fsa(END_REPLACEMENTS)

export const SUBMIT_SELECT_ITEMS = 'replacements/submits the answers for the select items step'
export const submitSelectItems = fsaPayload(SUBMIT_SELECT_ITEMS)

export const SUBMIT_SELECT_ISSUES = 'replacements/submits the answers for the select issues step'
export const submitSelectIssues = fsaPayload(SUBMIT_SELECT_ISSUES)

export const SUBMIT_FIT_QUESTIONNAIRE =
  'replacements/submits the answers for the fit questionnaire step'
export const submitFitQuestionnaire = fsaPayload(SUBMIT_FIT_QUESTIONNAIRE)

export const SUBMIT_TAILORING_NO_EXCHANGE =
  'replacements/submits the answer on the tailoring step to take to the tailor'
export const submitTailoringNoExchange = fsa(SUBMIT_TAILORING_NO_EXCHANGE)

export const SUBMIT_TAILORING_CONTINUE_EXCHANGE =
  'replacements/submits the answer on the tailoring step to continue request for exchange'
export const submitTailoringContinueExchange = fsa(SUBMIT_TAILORING_CONTINUE_EXCHANGE)

export const SUBMIT_SUMMARY = 'replacements/submits the summary step'
export const submitSummary = fsa(SUBMIT_SUMMARY)

export const EDIT_ISSUE = 'replacements/edit issue for item'
export const editIssue = fsaPayload(EDIT_ISSUE)

export const TOGGLE_COLLAR_EXTENDER_NEEDED = 'replacements/toggles isCollarExtenderNeeded flag'
export const toggleCollarExtenderNeeded = fsaPayload(TOGGLE_COLLAR_EXTENDER_NEEDED)

export const SET_FIT_DATA = 'replacements/set fit data'
export const setFitData = fsaPayloadByKeys(SET_FIT_DATA, ['fitOption', 'metaDataType'])

/**
 * GET product sizes for item API Actions
 */
export const GET_PRODUCT_SIZES_FOR_EXCHANGE = 'replacements/get product sizes for item'
export const getProductSizesForExchange = fsa(GET_PRODUCT_SIZES_FOR_EXCHANGE)

export const GET_PRODUCT_SIZES_FOR_EXCHANGE_PENDING = 'replacements/get product sizes pending'
export const getProductSizesForExchangePending = fsa(GET_PRODUCT_SIZES_FOR_EXCHANGE_PENDING)

export const GET_PRODUCT_SIZES_FOR_EXCHANGE_SUCCESS =
  'replacements/get product sizes successfully fetched'
export const getProductSizesForExchangeSuccess = fsaPayload(GET_PRODUCT_SIZES_FOR_EXCHANGE_SUCCESS)

export const GET_PRODUCT_SIZES_FOR_EXCHANGE_FAILURE = 'replacements/get product sizes fetch failed'
export const getProductSizesForExchangeFailure = fsaError(GET_PRODUCT_SIZES_FOR_EXCHANGE_FAILURE)

/**
 * POST submit exchange request API Actions
 */
export const SUBMIT_EXCHANGE_REQUEST = 'replacements/submit exchange request'
export const submitExchangeRequest = fsaPayload(SUBMIT_EXCHANGE_REQUEST)

export const SUBMIT_EXCHANGE_REQUEST_PENDING = 'replacements/submit exchange request pending'
export const submitExchangeRequestPending = fsa(SUBMIT_EXCHANGE_REQUEST_PENDING)

export const SUBMIT_EXCHANGE_REQUEST_SUCCESS = 'replacements/submit exchange request successful'
export const submitExchangeRequestSuccess = fsaPayload(SUBMIT_EXCHANGE_REQUEST_SUCCESS)

export const SUBMIT_EXCHANGE_REQUEST_FAILURE = 'replacements/submit exchange request failed'
export const submitExchangeRequestFailure = fsaError(SUBMIT_EXCHANGE_REQUEST_FAILURE)

/**
 * GET shipping address for order API Actions
 */
export const GET_SHIPPING_ADDRESS_FOR_EXCHANGE_PENDING =
  'replacements/get shipping address for exchange order pending'
export const getShippingAddressForExchangePending = fsa(GET_SHIPPING_ADDRESS_FOR_EXCHANGE_PENDING)

export const GET_SHIPPING_ADDRESS_FOR_EXCHANGE_SUCCESS =
  'replacements/get shipping address for exchange order successful'
export const getShippingAddressForExchangeSuccess = fsaPayload(
  GET_SHIPPING_ADDRESS_FOR_EXCHANGE_SUCCESS,
)

export const GET_SHIPPING_ADDRESS_FOR_EXCHANGE_FAILURE =
  'replacements/get shipping address for exchange order failed'
export const getShippingAddressForExchangeFailure = fsaError(
  GET_SHIPPING_ADDRESS_FOR_EXCHANGE_FAILURE,
)
